import * as React from 'react'

import { cn } from '../lib/utils'
import {
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  Card as UiCard,
} from './ui/card'

// Wrapper to preserve the legacy (token-based) Card styling while using a single
// underlying implementation from `src/components/ui/card.tsx`.
const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <UiCard
      ref={ref}
      className={cn('bg-card text-card-foreground border shadow-sm', className)}
      {...props}
    />
  )
)
Card.displayName = 'Card'

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
